import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { bkgdTileBlue, bkgdPolygon } from '.'

export const BuiltForYouSectionWrapper = styled.section`
  display: grid;
  justify-items: center;
  background-image: url(${bkgdPolygon}), url(${bkgdTileBlue});
  background-size: 65%, 40px;
  background-repeat: no-repeat, repeat;
  background-position: center 90%, center;
  padding: calc(100vw / 11) 0 32px;
  margin-top: calc(100vw / -11);
  position: relative;
  z-index: 1;
  clip-path: polygon(0 calc(100vw / 11), 100% 0, 100% 100%, 0 100%);

  @media (min-width: 1800px) {
    padding-top: 128px;
    margin-top: -128px;
    clip-path: polygon(0 128px, 100% 0, 100% 100%, 0 100%);
  }
`

export const LaptopContainer = styled.div`
  display: grid;
  padding: 72px 0;

  @media (max-width: 714px) {
    padding: 72px 0 48px;
    min-height: 400px;
    min-width: 325px;
  }

  @media (max-width: 500px) {
    padding: 24px 0 0;
    justify-items: center;
  }
`

export const Laptop = styled.img`
  height: 400px;
  grid-column: 1;
  grid-row: 1;

  @media (max-width: 900px) { height: 300px; }
`

const topChibis = css`
  right: 75px;
  bottom: 50px;

  @media (max-width: 500px) { right: unset; bottom: unset; }
`

const bottomChibis = css`
  align-self: end;
  top: 25px;
  right: 25px;

  @media (max-width: 500px) {align-self: unset; top: unset; right: unset; padding-bottom: 12px; }
`
const rightChibi = css`
  justify-self: end;
  align-self: center;
  left: 75px;
  bottom: 50px;

  @media (max-width: 500px) { justify-self: unset; left: unset; bottom: unset; }
`

export const Chibis = styled.img<{ position: 'top' | 'bottom' | 'right' }>`
  position: relative;
  height: 200px;
  grid-column: 1;
  grid-row: 1;

  ${({ position }) => position === 'top' && topChibis}
  ${({ position }) => position === 'bottom' && bottomChibis}
  ${({ position }) => position === 'right' && rightChibi}

  @media (max-width: 900px) { height: 175px; }
  @media (max-width: 500px) { width: 250px; height: unset;  grid-column: unset; grid-row: unset; }
`
